import React, { useState } from 'react';
import { Tabs, Typography } from 'antd';
import {
  CalendarOutlined,
  DollarOutlined,
  ToolOutlined,
  GlobalOutlined,
} from '@ant-design/icons';
import FiscalYearManagement from './FiscalYearManagement';
import BudgetManagement from './BudgetManagement';
import FixedAssetManagement from './FixedAssetManagement';
import CurrencyManagement from './CurrencyManagement';

const { Title, Text } = Typography;

const AdvancedFeatures: React.FC = () => {
  const [activeTab, setActiveTab] = useState('fiscal-years');

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: 24 }}>
        <Title level={2} style={{ margin: 0 }}>Advanced Features</Title>
        <Text type="secondary">Fiscal Years, Budgets, Fixed Assets, and Multi-Currency</Text>
      </div>

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        size="large"
        items={[
          {
            key: 'fiscal-years',
            label: (
              <span>
                <CalendarOutlined />
                Fiscal Years
              </span>
            ),
            children: <FiscalYearManagement />
          },
          {
            key: 'budgets',
            label: (
              <span>
                <DollarOutlined />
                Budgets
              </span>
            ),
            children: <BudgetManagement />
          },
          {
            key: 'assets',
            label: (
              <span>
                <ToolOutlined />
                Fixed Assets
              </span>
            ),
            children: <FixedAssetManagement />
          },
          {
            key: 'currencies',
            label: (
              <span>
                <GlobalOutlined />
                Multi-Currency
              </span>
            ),
            children: <CurrencyManagement />
          }
        ]}
      />
    </div>
  );
};

export default AdvancedFeatures;
